<template>
  <li class="sidebar__nav-menu-list-item">
    <BaseLink
      v-b-toggle="elementId"
      class="nav-link sidebar__nav-menu-link"
      href="javascript:;"
      :active="activeMenu"
    >
      <font-awesome-icon
        class="fa-fw mr-2 sidebar__nav-menu-icon"
        :icon="menuIcon"
      />

      <span class="sidebar__nav-menu-text">
        {{ menuText }}
      </span>

      <font-awesome-icon
        class="fa-fw sidebar__nav-menu-caret ml-auto"
        :icon="menuCaretIcon"
      />
    </BaseLink>

    <b-collapse
      :id="elementId"
      v-model="open"
      tag="ul"
      class="sidebar__nav-sub-menu list-unstyled"
    >
      <template v-for="(subMenu, $idx) in children">
        <li
          v-if="!subMenu.condition || subMenu.condition()"
          :key="$idx"
        >
          <BaseLink
            class="sidebar__nav-sub-menu-link"
            :to="subMenu.route"
            :href="subMenu.href"
            :target="subMenu.target"
            :data-cy="subMenu['data-cy']"
            exact
          >
            <font-awesome-icon
              v-if="subMenu.menuIcon"
              class="fa-fw mr-2 sidebar__nav-menu-icon"
              :icon="subMenu.menuIcon"
            />
            {{ subMenu.subMenuText }}
            <font-awesome-icon
              v-if="subMenu.target === '_blank'"
              class="fa-fw ml-2"
              style="font-size: 0.75rem; opacity: 0.7;"
              :icon="['fas', 'external-link-alt']"
            />
            <b-badge
              v-if="subMenu.badge"
              variant="primary"
              class="ml-2"
              style="font-size: 0.6rem; vertical-align: text-top;"
            >
              {{ subMenu.badge }}
            </b-badge>
          </BaseLink>
        </li>
      </template>
    </b-collapse>
  </li>
</template>

<script>
import { mapState } from 'vuex'

function checkMultipleRouteNames(routeName = '', routeNames, splitBy = '|') {
  const routeNamesSplit = routeNames.split(splitBy)

  return routeNamesSplit.some(route => routeName === route)
}

export default {
  name: 'SidebarNavDropdown',

  props: {
    route: {
      type: String,
      default: ''
    },

    menuText: {
      type: String,
      default: ''
    },

    menuIcon: {
      type: Array,
      default() {
        return []
      }
    },

    children: {
      type: Array,
      default() {
        return []
      }
    },

    show: {
      type: Boolean,
      default: false
    }

  },

  data() {
    return {
      open: this.show
    }
  },


  computed: {
    ...mapState(['isSidebarExpanded']),

    menuCaretIcon() {
      return this.isSidebarExpanded ? ['fas', 'angle-down'] : ['fas', 'angle-right']
    },

    activeMenu() {
      return checkMultipleRouteNames(this.$route.name, this.route)
    },

    elementId() {
      return `id-${this.menuText.replace(/[^a-zA-Z0-9]/g, '-')}`
    }
  },

  created () {
    this.open = checkMultipleRouteNames(this.$route.name, this.route)
  },
}
</script>

<style>

</style>